module.exports = __webpack_public_path__ + "img/abena_vit.d65522fe.svg";